<template>
  <div class="session-bar">
    <span v-if="sessionBar.showRoomName && room">{{ room.name }}:</span>
    <span v-if="sessionBar.showTime && session">{{ session.start | time }} - {{ session.end | time }}</span>
    <span v-if="sessionBar.showSessionName && session">{{ session.name }}</span>
    <span v-if="sessionBar.showSpeakers && speakers">({{ speakers }})</span>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  data () {
    return {
      session: null,
      checkInterval: null
    }
  },

  computed: {
    ...mapState('common', {
      sessionBar: state => state.virtual.sessionBar,
    }),

    ...mapGetters('common', [
      'roomById'
    ]),

    room () {
      const roomId = this.$route.params.roomId
      if (!roomId) {
        return ''
      }

      return this.roomById(parseInt(roomId))
    },

    speakers () {
      const { session } = this
      if (!session) {
        return ''
      }

      const speakers = session.speakers.slice().sort((a, b) => {
        a = a[this.sortBy]
        b = b[this.sortBy]

        return a === b ? 0 : a.localeCompare(b) < 0 ? -1 : 1
      })

      let speakersText = ''

      speakers.forEach((speaker, index) => {
        if (index != 0) {
          speakersText += '; '
        }

        if (speaker.degree_before) {
          speakersText += `${speaker.degree_before} `
        }
        speakersText += `${speaker.name} ${speaker.surname}`
        if (speaker.degree_after) {
          speakersText += `, ${speaker.degree_after}`
        }
      })

      return speakersText
    }
  },

  created () {
    this.checkSession()
    this.checkInterval = setInterval(this.checkSession, 10000)
  },

  beforeDestroy () {
    clearInterval(this.checkInterval)
  },

  methods: {
    checkSession () {
      const { room } = this
      if (!room) {
        this.session = null
      } else {
        this.session = this.$store.getters['sessions/currentSession'](room ? room.id : null)
      }
    }
  }
}
</script>
